import { render, staticRenderFns } from "./WebflowLayoutHeaderFooter.vue?vue&type=template&id=c6c89088"
import script from "./WebflowLayoutHeaderFooter.vue?vue&type=script&lang=js"
export * from "./WebflowLayoutHeaderFooter.vue?vue&type=script&lang=js"
import style0 from "./WebflowLayoutHeaderFooter.vue?vue&type=style&index=0&id=c6c89088&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports